import { getEnv } from '~/env';

export const termConfig = {
  termOfUseJa: getEnv('REACT_APP_ENDPOINT_SERVICE_TERMS_OF_USE_JA'),
  termOfUseEn: getEnv('REACT_APP_ENDPOINT_SERVICE_TERMS_OF_USE_EN'),
  termOfUseDevelopmentJa: getEnv('REACT_APP_DEVELOPMENT_PROGRAM_TERMS_OF_USE_JA'),
  termOfUseDevelopmentEn: getEnv('REACT_APP_DEVELOPMENT_PROGRAM_TERMS_OF_USE_EN'),
};
